import React, { useEffect, useContext } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import MachineList from './MachineList';
import MachineListGrouped from './MachineListGrouped';
// import InboxIcon from '@material-ui/icons/MoveToInbox';
import MenuIcon from '@material-ui/icons/Menu';
import { MyContext } from './MyContext';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

export default function MachineSelectDrawer() {
  const classes = useStyles();
  const [selectedCount, setSelectedCount] = React.useState(0);
  const { selectedMachines, data } = useContext(MyContext);
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  useEffect(() => {
    setSelectedCount(selectedMachines.length);
  }, [selectedMachines]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  // This approach does not seem to work
  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
          <ListItem button key={text}>

            {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {['All mail', 'Trash', 'Spam'].map((text, index) => (
          <ListItem button key={text}>
            {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <div>

      {['right'].map((anchor) => (
        <React.Fragment>
          <Tooltip TransitionComponent={Zoom} title="Click and select specific machines to view">
            <Button color="inherit" onClick={toggleDrawer(anchor, true)} style={{ align: 'right', textTransform: 'none' }}>
              <Typography variant="subtitle1" align="right" >Machines ({selectedCount})
              </Typography><MenuIcon />


            </Button>
          </Tooltip>
          <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}
          // 3/29/2024 need to use variant temporary and keepMounted true otherwise the MachineList components get recreated every open/close cycle
           // variant="temporary"
            ModalProps={{
              keepMounted: true,
            }}>

            {data?.machinegroupsupported ? <MachineListGrouped /> : <MachineList />}

          </Drawer>

        </React.Fragment>
      ))}

    </div>
  );
}
